import { observer } from 'mobx-react-lite';
import { TodayTimeCell } from './today-time-cell';
import columnDefinitionEnum from '../../../queues/column-definition.enum';
import { ScheduledEventQueueRowData } from '../../../socket/stream-types';

export const ScheduledTimeCell = observer(function ScheduledTimeCell({
    data,
}: {
    data: ScheduledEventQueueRowData;
}): React.ReactElement {
    return (
        <TodayTimeCell
            dateStr={data.targetOnSceneTime}
            columnDefinitionName={columnDefinitionEnum.SCHEDULED_TIME.name}
        />
    );
});
